module.exports = __webpack_public_path__ + "img/natural-parallax2.baab970c.jpg";